.panel {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--tuna-spacing-3);
  padding: var(--tuna-spacing-4);
  border: 1px solid var(--tuna-border-default);
  border-radius: var(--tuna-shape-borderRadius);
}

.title {
  margin: 0;
  font-size: var(--tuna-typography-h6-fontSize);
}

.title:focus {
  outline: none;
}

.body {
  margin: 0;
  font-size: var(--tuna-typography-body2-fontSize);
}

.halves,
.actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--tuna-spacing-2);
}

.halves > *,
.actions > * {
  min-height: 44px;
}
